export default __webpack_public_path__ + "static/media/LandingMain.25d1d5d0.svg";